import { useRef, useState } from "react";

// Cursor-aware 3D tilt card (disabled on touch devices).
export const TiltCard = ({ children, className = "", testId, maxTilt = 7 }) => {
  const ref = useRef(null);
  const [style, setStyle] = useState({
    transform: "perspective(900px) rotateX(0deg) rotateY(0deg)",
    transition: "transform 220ms ease-out",
  });
  const [glare, setGlare] = useState({ x: "50%", y: "50%", o: 0 });

  const handleMove = (e) => {
    if (e.pointerType === "touch") return;
    const el = ref.current;
    if (!el) return;
    const r = el.getBoundingClientRect();
    const px = (e.clientX - r.left) / r.width - 0.5;
    const py = (e.clientY - r.top) / r.height - 0.5;
    setStyle({
      transform: `perspective(900px) rotateX(${(-py * maxTilt).toFixed(2)}deg) rotateY(${(px * maxTilt).toFixed(2)}deg) translateY(-4px)`,
      transition: "transform 80ms ease-out",
    });
    setGlare({ x: `${(px + 0.5) * 100}%`, y: `${(py + 0.5) * 100}%`, o: 1 });
  };

  const handleLeave = () => {
    setStyle({
      transform: "perspective(900px) rotateX(0deg) rotateY(0deg)",
      transition: "transform 320ms ease-out",
    });
    setGlare((g) => ({ ...g, o: 0 }));
  };

  return (
    <div
      ref={ref}
      data-testid={testId}
      onPointerMove={handleMove}
      onPointerLeave={handleLeave}
      style={style}
      className={`relative will-change-transform ${className}`}
    >
      <div
        className="pointer-events-none absolute inset-0 rounded-[inherit] transition-opacity duration-300"
        style={{
          opacity: glare.o * 0.5,
          background: `radial-gradient(420px circle at ${glare.x} ${glare.y}, rgba(245,230,208,0.14), transparent 45%)`,
        }}
      />
      {children}
    </div>
  );
};
